import { lazy } from 'react'

export const LoginLazy = lazy(() => import('./Login'))
